import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PrivacyEffects, privacyReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([PrivacyEffects]), StoreModule.forFeature(`privacy`, privacyReducer)]
})
export class PrivacyStateModule {}
